import { Box, FileText, Tag, CalendarDays } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatDate } from "@/utils/helper";

interface AssetInfoProps {
  assetTypeName?: string;
  requestType?: string;
  description?: string;
  requestDate?: string | null;
}

const AssetInfo = ({
  assetTypeName,
  requestType,
  description,
  requestDate,
}: AssetInfoProps) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1.5 text-sm text-gray-700">
        <Box size={16} className="text-gray-400 shrink-0" />
        <span>{assetTypeName ?? "-"}</span>
      </div>
      <div className="flex items-center gap-1.5 text-sm text-gray-500">
        <Tag size={16} className="text-gray-400 shrink-0" />
        <span className="capitalize">
          {requestType?.replace(/-/g, " ") ?? "-"}
        </span>
      </div>
      {description && (
        <div className="flex items-center gap-1.5 text-sm text-gray-500">
          <FileText size={16} className="text-gray-400 shrink-0" />
          <span className="line-clamp-2">{description}</span>
        </div>
      )}
      {requestDate && (
        <div className="flex items-center gap-1.5 text-xs text-gray-400 pt-0.5">
          <CalendarDays size={13} className="text-gray-400 shrink-0" />
          <span>
            {t("common:request_detail.submitted_on", {
              date: formatDate(requestDate),
            })}
          </span>
        </div>
      )}
    </div>
  );
};

export default AssetInfo;
